module.exports = __webpack_public_path__ + "img/7.3aa8e7d1.jpeg";